import Box from '../../components/Box/Box.tsx';
import Column from '../../components/Grid/Column.tsx';
import Grid from '../../components/Grid/Grid.tsx';
import Row from '../../components/Grid/Row.tsx';
import TextInputContainer from '../../containers/TextInputContainer.tsx';
import Title from '../../components/Title/Title.tsx';
import { Button, ButtonSize, ButtonType } from '../../components/Button';
//import { isValidPhoneNumber } from 'react-phone-number-input';
import { Link } from 'react-router-dom';
import { LoginFormProps, LoginFormType, TFormField } from './types';
//import { preparePhoneString } from '@components/TextInput/TextInput';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Text, TextSize } from '@components/Text';
import { VITE_APP_API_URL } from "@utils/config";

const links2 = `${VITE_APP_API_URL}/v1/files/public-offers/ozon.pdf`;
const links3 = `${VITE_APP_API_URL}/v1/files/public-offers/yandex.pdf`;
const linksCR = `${VITE_APP_API_URL}/v1/files/public-offers/customer-returns.docx`;
const linksCN = `${VITE_APP_API_URL}/v1/files/public-offers/main-offer.pdf`;
const linksFBP = `${VITE_APP_API_URL}/v1/files/public-offers/fbp.pdf`;

const LoginForm = (props: LoginFormProps) => {
  const { onSubmit, isAdmin, pending } = props;

  const [sellerEmailOrPhoneErrorText, setSellerEmailOrPhoneErrorText] = useState<string>('');

  const { t } = useTranslation();

  const { control, handleSubmit, watch } = useForm<LoginFormType>({
    defaultValues: {
      email: "",
      emailAdmin: "",
      sellerEmailOrPhone: "",
      password: "",
    },
  });

  const sellerFiledValue = watch('sellerEmailOrPhone');

  const detectType = (value: string): 'email' | 'phone' | 'unknown' => {
    if (!value) return 'unknown';
    if (/@/.test(value)) return 'email';
    if (/[a-zA-Z]/.test(value)) return 'email';
    if (/^[+\d]/.test(value)) return 'phone';
    return 'unknown';
  };

  useEffect(() => {
    if (isAdmin) {
      if (sellerFiledValue.length) {
        const type = detectType(sellerFiledValue);
        if (type === 'email') {
          setSellerEmailOrPhoneErrorText(
              /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/.test(String(sellerFiledValue).toLowerCase())
                  ? ''
                  : t('defaultFormErrors.email') as string
          );
          return;
        }
        if (type === 'phone') {
         // setSellerEmailOrPhoneErrorText(
        //      isValidPhoneNumber(preparePhoneString(sellerFiledValue))
        //          ? ''
        //          : t('defaultFormErrors.phone') as string
        //  );
        }
      } else {
        setSellerEmailOrPhoneErrorText('');
      }
    }
  }, [isAdmin, sellerFiledValue]);

  const emailField: TFormField = {
    control,
    name: 'email',
    rules: { required: t("loginForm.emailErrorText") },
    title: t("loginForm.email"),
    type: 'email'
  };
  const emailAdminField: TFormField = {
    control,
    name: 'emailAdmin',
    rules: { required: t("loginForm.emailErrorText") },
    title: t("loginForm.emailAdmin"),
    type: 'email'
  };
  const sellerEmailOrPhoneField: TFormField = {
    control,
    name: 'sellerEmailOrPhone',
    rules: { required: t("defaultFormErrors.required") },
    title: t("loginForm.sellerEmailOrPhone"),
    type: 'text'
  };
  const passwordField: TFormField = {
    control,
    name: 'password',
    rules: { required: t("loginForm.passwordErrorText") },
    title: t("loginForm.password"),
    type: 'password'
  };

  const formFields: TFormField[] = isAdmin ? [emailAdminField, passwordField, sellerEmailOrPhoneField] : [emailField, passwordField];

  const handlerOnSubmit = (): void => {
    !(isAdmin && sellerEmailOrPhoneErrorText.length) && handleSubmit(onSubmit)();
  };

  return (
    <Grid>
      <Row>
        <Column phone={12}>
          <Box pb={8}>
            <Title title={t("loginForm.title")} />
          </Box>
        </Column>
      </Row>
      {formFields.map((item: TFormField, index: number) => (
          <Row key={index}>
            <Column phone={12}>
              <Box pb={4}>
                <TextInputContainer
                    {...item}
                    {...(item.name === 'sellerEmailOrPhone' && sellerEmailOrPhoneErrorText.length && {
                      error: sellerEmailOrPhoneErrorText,
                      hasError: true
                    })}
                />
              </Box>
            </Column>
          </Row>
      ))}
      {!isAdmin && (
          <Row>
            <Column phone={12}>
              <Box pb={4} textAlign={"right"}>
                <Link to={"/send-email-to-reset-password"}>
                  {t("loginForm.resetPasswordLink")}
                </Link>
              </Box>
            </Column>
          </Row>
      )}

      <Row>
        <Column phone={12}>
          <Box pb={4}>
            <Text
              size={TextSize.S}
              dangerouslySetInnerHTML={{
                __html: t('loginForm.oferta', {
                  link: linksCN,
                  link2: links2,
                  link3: links3,
                  linkFBP: linksFBP,
                  linkCR: linksCR,
                })
              }}
            />
          </Box>
        </Column>
      </Row>

      <Row>
        <Column phone={12}>
          <Button
            title={t("loginForm.button")}
            type={ButtonType.BLOCK}
            size={ButtonSize.S}
            onClick={handlerOnSubmit}
            pending={pending}
          />
        </Column>
      </Row>
    </Grid>
  );
};

export default LoginForm;
